import { useState } from 'react';
import Axios from 'axios';
import { useAppSettings } from '../hooks/useAppSettings';

export const useDeleteCategoryDocument = () => {
    const { settings: appSettings } = useAppSettings();
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    const deleteCategoryDocument = async (id: number): Promise<void> => {
        if (!appSettings?.api) {
            throw new Error('API settings not available');
        }

        setIsDeleting(true);
        setDeleteError(null);
        setDeleteSuccess(false);

        try {
            // Use Axios so the MSAL interceptor acquires a fresh token automatically
            await Axios.get(`${appSettings.api}DeleteCategoryDocument?id=${id}`);

            setDeleteSuccess(true);
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || 'Failed to delete category document';
            setDeleteError(message);
            throw new Error(`Delete failed (${error.response?.status ?? 'unknown'}): ${message}`);
        } finally {
            setIsDeleting(false);
        }
    };

    const clearMessages = () => {
        setDeleteError(null);
        setDeleteSuccess(false);
    };

    return {
        deleteCategoryDocument,
        isDeleting,
        deleteError,
        deleteSuccess,
        clearMessages,
    };
};
